import { Box, FormControlLabel, Typography } from '@/shared/ui';
import Checkbox from '@/shared/ui/primitives/Checkbox';
import EllipsisWithTooltip from '@/shared/ui/primitives/EllipsisWithTooltip';

const rowSx = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1
};

const hiddenCheckboxSx = { visibility: 'hidden' } as const;

interface FilterOptionRowProps {
  label: string;
  count: number;
  checked: boolean;
  onChange: () => void;
  showCount?: boolean;
}

const FilterOptionRow = ({
  label,
  count,
  checked,
  onChange,
  showCount = true
}: FilterOptionRowProps) => {
  const isEmpty = count === 0;

  return (
    <FormControlLabel
      disabled={isEmpty}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={isEmpty ? hiddenCheckboxSx : undefined}
        />
      }
      label={
        <Box sx={[rowSx, isEmpty && (theme => ({ color: theme.palette.gx.muted }))]}>
          <EllipsisWithTooltip text={label} />
          {showCount && (
            <Typography
              size={10}
              sx={theme => ({ color: isEmpty ? theme.palette.gx.muted : theme.palette.gx.border })}
            >
              {count.toLocaleString('en-US')}
            </Typography>
          )}
        </Box>
      }
      sx={{ ml: 0, width: '100%', '& .MuiFormControlLabel-label': { width: '100%' } }}
    />
  );
};

export default FilterOptionRow;
